<app-user-header class="d-md-none"></app-user-header> 
<div class="row m-0 h-100 row-container"> 


  <div class="col-md-2 pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-admin-sidebar></app-admin-sidebar>
  </div>
  <div class="col-md-10 big-area p-0">

<div class="wrapperi">
    <div class="col-12 row mt-4">
        <div class="col-1"></div>
        <div class="col-10">
            <h2>Ilmoitukset</h2>
            <p>Tässä näet ilmoitukset</p>
            <div class="col-12 row p-0 m-0">
                <div class="col-4 p-0">
                    <div class=" formed-shadow bg1">
                        
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">{{users.length}}</h2>
                                <p class="white-text">Ilmoitusta</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-1 big-icon fa-user"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class=" formed-shadow bg2">
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">+100</h2>
                                <p class="white-text">lääkäriä</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-2 big-icon fa-search-plus"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-4 p-0">
                    <div class=" formed-shadow bg3">
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">10</h2>
                                <p class="white-text">Avattua profiilia</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-3 big-icon fa-lock-open"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-1"></div>
    </div>


  
  
    <div class="col-12 p-0 row m-0">
      <div class="col-1"></div>
      <div class="col-12 mt-4 col-md-10 p-0 input-cover ">
        <button class="btn btn-formed-main-black" routerLink="/admins/admin/add-company">Lisää yritys</button>
        <table class="table table-striped">
            <thead>
                <tr>
                    <td>Rekisteröity</td>
                    <td>Nimi</td>
                    <td>Tiedot</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of users">
                    <td>{{data.createdDate | formateDate}}</td>
                    <td>{{data.firstName}} {{data.lastName}}</td>
                    <td><button routerLink="/admins/admin/users/user/user-details/{{data._id}}" class="btn btn-formed-main-black">Tiedot</button></td>

                </tr>
            </tbody>
        </table>
        </div>

        <div class="col-1"></div>
  </div>

  </div>

    </div>